import { IPlanoCliente } from "../interfaces/IPlanoCliente";
import api from "./Api";
import Swal from "sweetalert2";

const BASE_URL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3';

class PlanoClienteService {

  async listarPorCliente(clienteId: number): Promise<IPlanoCliente[]> {
    try {
      const { data } = await api.get<IPlanoCliente[]>(`Cliente/${clienteId}/planos`, { baseURL: BASE_URL });
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return [];
    }
  }

  async adicionar(clienteId: number, planoId: number, qtd: number): Promise<IPlanoCliente | null> {
    try {
      const { data } = await api.post<IPlanoCliente>(`Cliente/${clienteId}/planos`, { planoId, qtd }, { baseURL: BASE_URL });
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return null;
    }
  }

  async atualizarQtd(clienteId: number, id: number, qtd: number): Promise<IPlanoCliente | null> {
    try {
      const { data } = await api.put<IPlanoCliente>(`Cliente/${clienteId}/planos/${id}`, { qtd }, { baseURL: BASE_URL });
      return data;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return null;
    }
  }

  async remover(clienteId: number, id: number): Promise<boolean> {
    try {
      await api.delete(`Cliente/${clienteId}/planos/${id}`, { baseURL: BASE_URL });
      return true;
    } catch (error: any) {
      Swal.fire({ text: error.message, timer: 4000, icon: 'error', showConfirmButton: false });
      return false;
    }
  }
}

export default new PlanoClienteService();
